module.exports = __webpack_public_path__ + "img/merge.8fe42645.svg";